import React, { useState, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Images.module.scss';

const Image = memo(({ url, expand, onSelect }) => {
  const onClick = useCallback(() => onSelect(expand ? '' : url), [
    expand,
    url,
    onSelect,
  ]);
  return (
    <img
      alt=""
      src={url}
      onClick={onClick}
      className={cx(expand && styles.expand)}
    />
  );
});

Image.propTypes = {
  url: PropTypes.string.isRequired,
  expand: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

const Images = memo(({ images }) => {
  const [selected, setSelected] = useState('');
  const handleSelect = useCallback(url => setSelected(url), []);
  return (
    <div className={styles.images}>
      {images.map(url => (
        <Image
          key={url}
          url={url}
          expand={url === selected}
          onSelect={handleSelect}
        />
      ))}
    </div>
  );
});

Images.propTypes = {
  images: PropTypes.array.isRequired,
};

export default Images;
